import { Tooltip, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';

type MonthYearCellProps = {
  forecast_date?: string | Date;
};

const MonthYearCell = React.memo((row: MonthYearCellProps) => {
  if (!row?.forecast_date) return null;

  const formattedDate = moment.utc(row?.forecast_date).format('MMM-YY');

  return (
    <Tooltip title={formattedDate}>
      <Typography variant="body2" noWrap>
        {formattedDate}
      </Typography>
    </Tooltip>
  );
});

export default MonthYearCell;
